import styled, { css } from "styled-components";

const Header = styled.div`
  flex: 0 0 35vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${({ home }) =>
    home &&
    css`
      align-items: flex-start;
    `}
`;

export default Header;
